/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MyInjector } from '@src/app/app.module';
import { Field } from '@src/app/shared/field/Field';
import { SectionEditor } from '@src/app/shared/form/section-editor';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { RequestService } from '@src/app/modules/crm/request.service';
import { AgentDataService } from '@src/app/modules/agent/agent-data.service';
import { BCode } from '@src/app/model/bcode';
import { Schedule } from '@src/app/model/schedule';

/**
 * "Edit the work order" popup - the supplier plus the money grid (budget code / schedule / amount).
 * The bCode and schedule lists are OMC-specific, so they load in beforeEdit once the request's
 * team is known; the grid picklists share the `bCodes` / `schedules` arrays by reference.
 */
export class RequestWorkOrderEditor extends SectionEditor<ServiceRequest> {
    protected svc = MyInjector.instance.get(RequestService);
    protected title = $localize`Work Order`;
    protected width = 660;

    private agentDataSvc = MyInjector.instance.get(AgentDataService);
    private bCodes: BCode[] = [];
    private schedules: Schedule[] = [];
    private teamId: string;

    protected buildFields(): Field[] {
        return [
            ServiceRequest.makeSupplierField(),
            ServiceRequest.makeBudgetGridField(this.bCodes, this.schedules, () => this.teamId),
        ];
    }

    protected beforeEdit(sr: ServiceRequest): ServiceRequest {
        this.teamId = sr.teamId;
        this.agentDataSvc.getOmcExpenseBCodes(sr.teamId).subscribe(bcodes => {
            this.bCodes.length = 0;
            this.bCodes.push(...bcodes);
        });
        this.agentDataSvc.getOmcSchedules(sr.teamId).subscribe(scheds => {
            this.schedules.length = 0;
            this.schedules.push(...scheds);
        });
        return sr;
    }
}
